export default {
  SET_HOTSITE_SLOTS: (state, hotsiteSlots) => (state.hotsiteSlots = hotsiteSlots),
}
